import { JsonSchemaValidator } from "@common/json-schema-validator";
import { brandOverlayEntityRaw } from "../../schema";
import { BrandOverlayEntityRaw } from "../../interface";
import { BaseEntity } from "../base.entity";

export class BrandOverlayEntity extends BaseEntity<BrandOverlayEntityRaw> {
  private static validation = JsonSchemaValidator.compile(
    brandOverlayEntityRaw
  );

  constructor(value: BrandOverlayEntityRaw) {
    super(JsonSchemaValidator.assert(BrandOverlayEntity.validation, value));
  }
}
